export enum enumPublishingState {
  DRAFT = 0,
  PUBLISHED = 100,
  APPROVED = 200,
  DELETED = 300,
}
